
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test-your-website",
      function () {
        return require("private-next-pages/test-your-website.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/test-your-website"])
      });
    }
  